import { render, staticRenderFns } from "./DrivewealthOptions.vue?vue&type=template&id=2d0704fc"
import script from "./DrivewealthOptions.vue?vue&type=script&lang=ts"
export * from "./DrivewealthOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports